import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import SessionLoader from './SessionLoader';
import loadSession from '../actions/loadSession';

const mapDispatchToProps = dispatch => bindActionCreators({
  loadSession,
}, dispatch);

export default connect(null, mapDispatchToProps)(SessionLoader);
